import { useCallback } from 'react';
import { POSTHOG_FEATURE_FLAGS } from '../../config/config';
import useFeatureFlags from './useFeatureFlags';

const useRewardsV2Flag = () => {
  const isRewardsV2Enabled = useCallback(
    () => useFeatureFlags(
      POSTHOG_FEATURE_FLAGS.REWARDS_V2_AB,
      POSTHOG_FEATURE_FLAGS.REWARDS_V2,
    ),
    [POSTHOG_FEATURE_FLAGS.REWARDS_V2_AB, POSTHOG_FEATURE_FLAGS.REWARDS_V2],
  );

  return isRewardsV2Enabled();
};

export default useRewardsV2Flag;
